import { defineMessages } from 'react-intl-next';
export var mediaLinkToolbarMessages = defineMessages({
  backLink: {
    id: 'fabric.editor.backLink',
    defaultMessage: 'Go back',
    description: 'Go back from media linking toolbar to main toolbar'
  }
});